// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.YXu8Jr6LqkuMy1aLzgsY{flex-direction:column;gap:8px;width:100%;padding:32px 0 24px;display:flex}.tJcRIG0bwEUUdVRNKE_e{height:40px}.tJcRIG0bwEUUdVRNKE_e.yVLIqlUbgTA8nKFJsv_E,.tJcRIG0bwEUUdVRNKE_e.PCc5ai1aIckwTRqLB7xT,.tJcRIG0bwEUUdVRNKE_e.Qwk7r8EDXyoRnWfAi6sc{background:linear-gradient(269deg,var(--action-contained-primary-normal)1.18%,var(--purple-70)98.82%)!important}.tJcRIG0bwEUUdVRNKE_e.yVLIqlUbgTA8nKFJsv_E{pointer-events:none}.tJcRIG0bwEUUdVRNKE_e.xDZ8GASNHwYXHHB9032Z,.tJcRIG0bwEUUdVRNKE_e.Qwk7r8EDXyoRnWfAi6sc{background:linear-gradient(269deg,var(--red-60)1.18%,var(--purple-70)98.82%)!important}.tJcRIG0bwEUUdVRNKE_e.PCc5ai1aIckwTRqLB7xT{color:var(--white-100)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `YXu8Jr6LqkuMy1aLzgsY`,
	"btn": `tJcRIG0bwEUUdVRNKE_e`,
	"loading": `yVLIqlUbgTA8nKFJsv_E`,
	"success": `PCc5ai1aIckwTRqLB7xT`,
	"disabled": `Qwk7r8EDXyoRnWfAi6sc`,
	"error": `xDZ8GASNHwYXHHB9032Z`
};
export default ___CSS_LOADER_EXPORT___;
